export const PersonData = [
  {
    name: "Kathy Rosenberg",
    position: "Product Mannager",
    email: "kathyr@gmail.com",
    image: require("./image/wallpaper.jpg"),
  },
  {
    name: "Alexandra Boyarskaya",
    position: "Support Marketing Specialist",
    email: "alexandrab@gmail.com",
    image: require("./image/wallpaper2.jpg")
  },
  {
    name: "Melani Amini",
    position: "Photographer",
    email: "melania@gmail.com",
    image: require("./image/wallpaper3.jpg")
  }
];
